<app-sticky [scrollThreshold]="scrollThreshold" [afterScrollThreshold]="0" [onlyMobile]="false">
  <div class="header" [class.expand-user-menu]="expandUserMenuState" [class.profile-header]="isProfilePage">
    <app-system-notifications class="translation-section notify"></app-system-notifications>
    <app-suggest-language-change class="translation-section"></app-suggest-language-change>
    <app-timezone-notifier></app-timezone-notifier>
    <app-currency-notifier></app-currency-notifier>
    <app-vacation-informer class="translation-section"></app-vacation-informer>
    <app-suggest-add-card *ngIf="!isMeVersion()" class="translation-section"></app-suggest-add-card>

    <ng-template [ngIf]="!isMeVersion()">
      <ng-template [ngIf]="showMainMenu()">
        <div class="row">
          <div class="content web-version">
            <ng-container *ngIf="deviceService.isDesktop()">
              <div class="menu"></div>
              <ng-container *ngTemplateOutlet="logoBlock"></ng-container>
              <div class="search-wrap">
                <div class="nav" itemscope itemtype="http://schema.org/SiteNavigationElement">
                  <span *ngFor="let item of menuItems; trackBy: trackByFn" [attr.title]="item.label | customLocale">
                    <a
                      *ngIf="isMenuItemEnabled(item)"
                      class="nav-item"
                      itemprop="url"
                      [class.active2]="isItemActive(item)"
                      [queryParams]="getQueryParams()"
                      [attr.data-test]="item.id"
                      [attr.title]="item.label | customLocale"
                      [routerLink]="item.url"
                      routerLinkActive="active">
                      <div class="nav-item-name">{{ item.label | customLocale }}</div>
                    </a>
                  </span>
                </div>
                <ng-template [ngIf]="deviceService.isDesktop()">
                  <ng-container *ngTemplateOutlet="searchBlock"></ng-container>
                </ng-template>
              </div>

              <div class="right-spacer">
                <app-language-selector></app-language-selector>
                <app-currency-selector *ngIf="isAvailableProfileFinance"></app-currency-selector>
                <app-timezone-selector *ngIf="!isGuest"></app-timezone-selector>
                <div class="user" (clickOutside)="options_open = false">
                  <ng-template [ngIf]="me && isGuest">
                    <div class="auth">
                      <span (click)="authorize('social')" data-test="sign-in" class="signin">{{
                        'auth.signin.action1' | customLocale
                      }}</span>
                      <span (click)="authorize('signup')" data-test="sign-up" class="signin">{{
                        'auth.signup.action1' | customLocale
                      }}</span>
                    </div>
                  </ng-template>
                  <div class="avatar-status-block" [class.avatar-status-block-mob]="!deviceService.isDesktop()">
                    <app-user-menu
                      [me]="me"
                      [verification_status_value]="verification_status"
                      (expandedMenu)="expandedUserMenuState($event)">
                    </app-user-menu>
                    <app-icon
                      [icon]="isNeedAction"
                      file="status"
                      [width]="20"
                      [height]="20"
                      *ngIf="isNeedAction"
                      class="status-icon">
                    </app-icon>
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="!deviceService.isDesktop()">
              <div class="left-spacer" *ngIf="!deviceService.isDesktop()">
                <div class="selectors-block">
                  <app-language-selector></app-language-selector>
                  <app-currency-selector *ngIf="isAvailableProfileFinance"></app-currency-selector>
                  <app-timezone-selector *ngIf="!isGuest"></app-timezone-selector>
                </div>

                <div *ngIf="isGuest" class="sign-wrap">
                  <span (click)="authorize('social')" class="sign-action">{{ 'auth.signin.action1' | customLocale }}</span>
                  <span (click)="authorize('signup')" class="sign-action">{{ 'auth.signup.action1' | customLocale }}</span>
                </div>
              </div>
              <div class="right-spacer">
                <div *ngIf="!isGuest" class="actions-block">
                  <a [routerLink]="'/users/subscriptions'" routerLinkActive="active"
                    ><app-icon file="sidebar-mobile-new" icon="followers"></app-icon
                  ></a>
                  <a [routerLink]="'/notifications'" routerLinkActive="active" class="chat-block">
                    <div class="chat-unread-count" *ngIf="unreadNotificationsCount$ | async as unread">
                      {{ unread < 99 ? unread : '99+' }}
                    </div>
                    <app-icon file="sidebar-mobile-new" icon="notifications"></app-icon>
                  </a>
                  <div class="chat-block" (click)="toggleChat()">
                    <div class="chat-unread-count" *ngIf="unreadCount > 0">{{ unreadCount }}</div>
                    <app-icon file="sidebar-mobile-new" icon="chat"></app-icon>
                  </div>
                </div>
                <div class="user" (clickOutside)="options_open = false">
                  <div class="avatar-status-block avatar-status-block-mob">
                    <app-user-menu
                      [me]="me"
                      [verification_status_value]="verification_status"
                      (expandedMenu)="expandedUserMenuState($event)">
                    </app-user-menu>
                    <app-icon
                      [icon]="isNeedAction"
                      file="status"
                      [width]="20"
                      [height]="20"
                      *ngIf="isNeedAction"
                      class="status-icon">
                    </app-icon>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>

          <ng-template [ngIf]="!deviceService.isDesktop()">
            <div class="search-wrap-mobile">
              <ng-container *ngTemplateOutlet="searchBlock"></ng-container>
            </div>
          </ng-template>
          <ng-template [ngIf]="!deviceService.isDesktop()">
            <div class="nav scroll" itemscope itemtype="http://schema.org/SiteNavigationElement">
              <span *ngFor="let item of menuItems; trackBy: trackByFn" [attr.title]="item.label | customLocale">
                <a
                  *ngIf="isMenuItemEnabled(item)"
                  class="nav-item"
                  itemprop="url"
                  [class.active2]="isItemActive(item)"
                  [queryParams]="getQueryParams()"
                  [attr.data-test]="item.id"
                  [attr.title]="item.label | customLocale"
                  [routerLink]="item.url"
                  routerLinkActive="active">
                  <div class="nav-item-name">{{ item.label | customLocale }}</div>
                </a>
              </span>
            </div>
          </ng-template>
        </div>

        <div class="row-2" *ngIf="deviceService.isDesktop()">
          <div class="line-2">
            <div class="left">
              <div class="menu">
                <app-icon
                  *ngIf="isTeacher"
                  (click)="showMenuWrap = true"
                  class="sidebar-icon"
                  icon="plus-green"></app-icon>
                <app-left-sidebar [floating]="false" [fromHeader]="true"></app-left-sidebar>

                <div
                  [ngStyle]="{ display: showMenuWrap ? 'block' : 'none' }"
                  (click)="showMenuWrap = false"
                  class="shade"></div>
                <div [ngStyle]="{ display: showMenuWrap ? 'block' : 'none' }" class="menu-wrapper">
                  <app-left-sidebar
                    [showAdditionalMenu]="true"
                    [floating]="false"
                    (onClickItem)="showMenuWrap = false"></app-left-sidebar>
                </div>
              </div>
            </div>
            <div class="right">
              <span class="item-text" (click)="onToggleIntroductionModal()">{{
                'user-menu.items.how-onclass-work' | customLocale
              }}</span>
              <span class="item-text" (click)="openCrispChat()">{{ 'user-menu.items.support' | customLocale }}</span>
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template [ngIf]="isConstructorPage">
        <div class="row">
          <div class="content constructor">
            <ng-container *ngTemplateOutlet="logoBlock"></ng-container>

            <div class="left-spacer">
              <div class="profile-bread-crumbs">
                <p (click)="goToMain()">{{ 'library.breadcrumbs.home' | customLocale }}</p>
                <app-icon class="chevron" [width]="6" [height]="10" icon="right" file="chevron"></app-icon>
                <p>{{ 'constructor2.steps.step-1.label' | customLocale }}</p>
              </div>
            </div>

            <div class="right-spacer">
              <ng-template [ngIf]="deviceService.isDesktop()">
                <app-language-selector></app-language-selector>
                <app-currency-selector></app-currency-selector>
              </ng-template>
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template [ngIf]="isProfilePage">
        <div class="row">
          <div class="content profile">
            <div class="menu" (click)="toggleLeftSidebar()">
              <ng-container *ngIf="!isAllStepsFilled; else defaultMenu">
                <app-icon class="left-sidebar-icon unfilled-icon" file="sidebar" icon="menu-unfilled"></app-icon>
              </ng-container>
              <ng-template #defaultMenu>
                <app-icon [width]="24" [height]="24" class="left-sidebar-icon" file="sidebar" icon="menu"></app-icon>
              </ng-template>
            </div>

            <ng-container *ngTemplateOutlet="logoBlock"></ng-container>

            <div class="left-spacer" *ngIf="deviceService.isDesktop()">
              <div class="profile-bread-crumbs">
                <p (click)="goToMain()">{{ 'library.breadcrumbs.home' | customLocale }}</p>
                <app-icon class="chevron" [width]="6" [height]="10" icon="right" file="chevron"></app-icon>
                <p>{{ 'onboarding.steps-widget.profile' | customLocale }}</p>
              </div>
            </div>

            <ng-container *ngIf="isOnModify">
              <div class="verification-send-block-on-header" *ngIf="isOnModify == 'send'">
                <p class="verification-send-text" *ngIf="deviceService.isDesktop()">
                  {{ 'verification-widget.description.changed' | customLocale }}
                </p>
                <on-ui-button
                  [state]="btnState"
                  class="third"
                  data-test="verification-send"
                  label="verification-widget.actions.send"
                  (click)="sendToVerification()">
                </on-ui-button>
              </div>
              <div class="verification-send-block-on-header" *ngIf="isOnModify == 'cancel'">
                <p class="verification-send-text" *ngIf="deviceService.isDesktop()">
                  {{ 'verification-widget.description.resent' | customLocale }}
                </p>
                <on-ui-button
                  [state]="btnState"
                  class="third"
                  data-test="verification-cancel"
                  label="verification-widget.actions.cancel"
                  (click)="cancelVerification()">
                </on-ui-button>
              </div>
            </ng-container>

            <div class="right-spacer">
              <app-language-selector></app-language-selector>
              <app-currency-selector></app-currency-selector>
            </div>
          </div>
        </div>
      </ng-template>
    </ng-template>

    <ng-template [ngIf]="isMeVersion()">
      <ng-template [ngIf]="showMainMenu()">
        <div class="row">
          <div class="content">
            <div class="menu" (click)="toggleLeftSidebar()">
              <app-icon [width]="24" [height]="24" class="left-sidebar-icon" file="sidebar" icon="menu"></app-icon>
            </div>

            <ng-container *ngTemplateOutlet="logoBlock"></ng-container>

            <div class="right-spacer">
              <div class="user" (clickOutside)="options_open = false">
                <ng-template [ngIf]="me && isGuest">
                  <div class="auth">
                    <span (click)="authorize('social')" data-test="sign-in" class="signin">{{
                      'auth.signin.action1' | customLocale
                    }}</span>
                    <span (click)="authorize('signup')" data-test="sign-up" class="signin">{{
                      'auth.signup.action1' | customLocale
                    }}</span>
                  </div>
                </ng-template>
                <div class="avatar-status-block" [class.avatar-status-block-mob]="!deviceService.isDesktop()">
                  <app-user-menu
                    [me]="me"
                    [verification_status_value]="verification_status"
                    (expandedMenu)="expandedUserMenuState($event)">
                  </app-user-menu>
                </div>
              </div>

              <ng-template [ngIf]="deviceService.isDesktop()">
                <app-language-selector></app-language-selector>
                <app-currency-selector></app-currency-selector>
              </ng-template>
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template [ngIf]="isConstructorPage">
        <div class="row">
          <div class="content constructor">
            <ng-container *ngTemplateOutlet="logoBlock"></ng-container>

            <div class="left-spacer">
              <div class="profile-bread-crumbs">
                <p (click)="goToMain()">{{ 'library.breadcrumbs.home' | customLocale }}</p>
                <app-icon class="chevron" [width]="6" [height]="10" icon="right" file="chevron"></app-icon>
                <p>{{ 'constructor2.steps.step-1.label' | customLocale }}</p>
              </div>
            </div>

            <div class="right-spacer">
              <ng-template [ngIf]="deviceService.isDesktop()">
                <app-language-selector></app-language-selector>
                <app-currency-selector></app-currency-selector>
              </ng-template>
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template [ngIf]="isProfilePage">
        <div class="row">
          <div class="content profile">
            <div class="menu" (click)="toggleLeftSidebar()">
              <app-icon [width]="24" [height]="24" class="left-sidebar-icon" file="sidebar" icon="menu"></app-icon>
            </div>

            <ng-container *ngTemplateOutlet="logoBlock"></ng-container>

            <div class="left-spacer">
              <div class="profile-bread-crumbs">
                <p (click)="goToMain()">{{ 'library.breadcrumbs.home' | customLocale }}</p>
                <app-icon class="chevron" [width]="6" [height]="10" icon="right" file="chevron"></app-icon>
                <p>{{ 'onboarding.steps-widget.profile' | customLocale }}</p>
              </div>
            </div>

            <div class="right-spacer">
              <ng-template [ngIf]="deviceService.isDesktop()">
                <app-language-selector></app-language-selector>
                <app-currency-selector></app-currency-selector>
              </ng-template>
            </div>
          </div>
        </div>
      </ng-template>
    </ng-template>
  </div>
</app-sticky>

<ng-template #logoBlock>
  <div class="brand">
    <a (click)="goToMain()" class="logo" aria-label="OnClass"></a>
  </div>
</ng-template>

<ng-template #searchBlock>
  <div class="search-block" [class.on-focus]="focus">
    <app-subject-selector></app-subject-selector>
    <app-icon class="search-content-icon" (click)="onTermChange()" file="sidebar" icon="search"></app-icon>
    <form (ngSubmit)="onTermChange(searchInput)" autocomplete="off">
      <input
        #searchInput
        type="text"
        enterkeyhint="search"
        class="search-input"
        [(ngModel)]="term"
        name="search"
        (clickOutside)="contentDisplay = false"
        (focus)="onFocus()"
        (blur)="onBlur()"
        [placeholder]="'subject-filters.search-input-placeholder' | customLocale" />
    </form>
    <app-icon class="search-icon-close" [class.visible]="!!term" (click)="clearSearchForm()" icon="close-search">
    </app-icon>

    <ng-template [ngIf]="contentDisplay && recentSearchesList.length">
      <div class="options" (click)="onOptionsClick($event)">
        <div class="header-block">
          <span class="recent">{{ 'subject-selector-in-header.recent' | customLocale }}</span>
          <span class="clear" (click)="deleteSearchHistory()">{{
            'subject-selector-in-header.clear' | customLocale
          }}</span>
        </div>
        <div class="option" *ngFor="let search of recentSearchesList">
          <div class="left" (click)="onTermSet(search)">
            <app-icon [width]="24" [height]="24" file="action" icon="clock"></app-icon>
            <span class="name">{{ search }}</span>
          </div>
          <app-icon class="hide-search" icon="close-search" (click)="deleteSearch(search)"></app-icon>
        </div>
      </div>
    </ng-template>
  </div>
</ng-template>

<app-modal
  *ngIf="openIntroductionModal && !deviceService.isMobile()"
  [canClose]="false"
  (closed)="onToggleIntroductionModal()">
  <app-modal-body>
    <app-first-contact></app-first-contact>
  </app-modal-body>
</app-modal>
<app-mobile-modal *ngIf="openIntroductionModal && deviceService.isMobile()" (closed)="onToggleIntroductionModal()">
  <app-mobile-modal-body>
    <app-first-contact></app-first-contact>
  </app-mobile-modal-body>
</app-mobile-modal>
